var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ccc"}},[_c('ul',{staticClass:"document"},_vm._l((_vm.searchList),function(item){return _c('li',{key:item.manga_id},[_c('keep-alive',[_c('Document',{attrs:{"item":item},on:{"reload":_vm.reload}})],1)],1)}),0),(_vm.isNoContent)?_c('div',{staticClass:"nothing"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("搜索无结果！"),_c('br'),_vm._v("Nothing Here!")])
}]

export { render, staticRenderFns }